module.exports = __webpack_public_path__ + "media/images/thanksgiving/bg-lg-ae745cf677efb95c95164cb36db73d06.jpg";